import React from 'react'
import PropTypes from 'prop-types'
import {
  PrintActionsWrapper,
  PrintButton,
  PrintStyles,
} from './component.styles'

const IndividualResourcePrintControls = ({ onPrint }) => {
  return (
    <>
      <PrintStyles />
      <PrintActionsWrapper data-print-hidden="print-button">
        <PrintButton onClick={onPrint}>Print</PrintButton>
      </PrintActionsWrapper>
    </>
  )
}

IndividualResourcePrintControls.propTypes = {
  onPrint: PropTypes.func.isRequired,
}

export default IndividualResourcePrintControls
